import { API_ENDPOINTS } from '../constants';

import { get, apiClient } from './apiClient';

export interface PermissionEntry {
  permission: string;
  scope: string;
  description: string;
}

export interface UserPermissionsResponse {
  user_id: number;
  role: string;
  district_id: number | null;
  school_id: number | null;
  permissions: PermissionEntry[];
  accessible_districts: number[];
  accessible_schools: number[];
}

export const fetchUserPermissions = async (tokenOverride?: string): Promise<UserPermissionsResponse> => {
  if (tokenOverride) {
    return await apiClient<UserPermissionsResponse>(API_ENDPOINTS.AUTH.PERMISSIONS, {
      method: 'GET',
      headers: { Authorization: `Bearer ${tokenOverride}` },
    });
  }
  return await get<UserPermissionsResponse>(API_ENDPOINTS.AUTH.PERMISSIONS);
};


